// extracted by mini-css-extract-plugin
export default {"select":"SelectUI_select__7q3jo","fullWidth":"SelectUI_fullWidth__cqjeK"};